import { GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
interface LogoProps {
  variant?: "light" | "dark" | "auto";
  size?: "sm" | "md" | "lg";
}
const Logo = ({
  variant = "auto",
  size = "md"
}: LogoProps) => {
  const sizes = {
    sm: {
      icon: "w-8 h-8",
      iconInner: "w-4 h-4",
      text: "text-lg"
    },
    md: {
      icon: "w-10 h-10",
      iconInner: "w-5 h-5",
      text: "text-xl"
    },
    lg: {
      icon: "w-12 h-12",
      iconInner: "w-6 h-6",
      text: "text-2xl"
    }
  };
  const textColor = variant === "light" ? "text-primary-foreground" : variant === "dark" ? "text-foreground" : "text-foreground";
  return <Link to="/" className="flex items-center gap-3">
      <div className={`${sizes[size].icon} rounded-xl bg-gradient-primary flex items-center justify-center`}>
        <GraduationCap className={`${sizes[size].iconInner} text-primary-foreground`} />
      </div>
      <span className={`font-display ${sizes[size].text} font-bold ${textColor}`}>TERALEARN</span>
    </Link>;
};
export default Logo;